import { createRouter, createWebHistory } from 'vue-router'
import FeedbackForm from '@/views/FeedbackForm.vue'
import PositiveReview from '@/views/PositiveReview.vue'
import ComplaintForm from '@/views/ComplaintForm.vue'
import InquiryForm from '@/views/InquiryForm.vue'
import ThankYou from '@/views/ThankYou.vue'
import AdminLogin from '@/views/AdminLogin.vue'
import AdminDashboard from '@/views/AdminDashboard.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/f'
    },
    {
      path: '/f',
      name: 'feedback',
      component: FeedbackForm
    },
    {
      path: '/positive',
      name: 'positive',
      component: PositiveReview
    },
    {
      path: '/complaint',
      name: 'complaint',
      component: ComplaintForm
    },
    {
      path: '/inquiry',
      name: 'inquiry',
      component: InquiryForm
    },
    {
      path: '/thank-you',
      name: 'thank-you',
      component: ThankYou
    },
    {
      path: '/admin/login',
      name: 'admin-login',
      component: AdminLogin
    },
    {
      path: '/admin/dashboard',
      name: 'admin-dashboard',
      component: AdminDashboard
    },
    {
      path: '/admin',
      redirect: '/admin/login'
    },
    // Handle customer name with car (pathMatch captures everything after customer name)
    {
      path: '/:name/:car(.*)*',
      redirect: (to) => {
        const name = to.params.name as string
        const car = Array.isArray(to.params.car) 
          ? to.params.car.join('/') 
          : to.params.car as string
        
        return {
          path: '/f',
          query: { 
            t: name, 
            c: car 
          }
        }
      }
    },
    // Handle single parameter - customer name only
    {
      path: '/:name',
      redirect: (to) => {
        const name = to.params.name as string
        
        return {
          path: '/f',
          query: { t: name }
        }
      }
    }
  ]
})

export default router 